<script></script>

<div class="attribution">
  <p>Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. Coded by <a href="https://github.com/brasspetals" target="_blank">Anna</a>.</p>
</div>

<style>
  .attribution {
    font-size: 0.875rem;
    color: var(--color-green);
    text-align: center;
    width: 100%; 
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 1.5rem;
  }

  a {
    font-family: "Fraunces", serif;
    color: var(--color-dark-green);
    transition: color .2s ease;
  }

  a:hover {
    color: var(--color-white);
  }

  a:focus-visible {
   outline: 0.125rem dashed var(--color-white);
  }
</style>